/**
 * Utility to handle mobile viewport height issues with browser address bars
 * This is a fallback for browsers that don't support the new viewport units (dvh, svh, lvh)
 */

// Check if the browser supports the new viewport units
function supportsViewportUnits() {
  // Create a test element
  const testEl = document.createElement('div');
  testEl.style.height = '100dvh';
  document.body.appendChild(testEl);
  
  // Check if the browser applied the dvh unit
  const hasDvh = testEl.style.height === '100dvh';
  
  // Clean up
  document.body.removeChild(testEl);
  
  return hasDvh;
}

// Function to set the viewport height CSS variable
export function setViewportHeight() {
  // First we get the viewport height and multiply it by 1% to get a value for a vh unit
  const vh = window.innerHeight * 0.01;
  
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  
  // Calculate offset for mobile browsers with address bars
  const offset = window.outerHeight - window.innerHeight;
  document.documentElement.style.setProperty('--vh-offset', `${offset}px`);
}

// Initialize viewport height
export function initViewportHeight() {
  // Only use this fallback if the browser doesn't support the new viewport units
  if (!supportsViewportUnits()) {
    console.log('Browser does not support modern viewport units (dvh, svh, lvh). Using fallback.');
    
    // Set the height initially
    setViewportHeight();
    
    // Add event listener to update the height on resize
    window.addEventListener('resize', () => {
      setViewportHeight();
    });
    
    // Add event listener for orientation changes
    window.addEventListener('orientationchange', () => {
      // Small delay to ensure the browser has updated the viewport
      setTimeout(() => {
        setViewportHeight();
      }, 100);
    });
    
    // Add event listener for scroll to handle address bar hiding/showing
    window.addEventListener('scroll', () => {
      // Debounce the scroll event
      if (!window.scrollTimeout) {
        window.scrollTimeout = setTimeout(() => {
          setViewportHeight();
          window.scrollTimeout = null;
        }, 200);
      }
    });
  } else {
    console.log('Browser supports modern viewport units (dvh, svh, lvh). No fallback needed.');
  }
}

export default initViewportHeight;